import React, { useEffect, useState, useContext } from "react";
import MUIDataTable from "mui-datatables"; 

import { services } from "../services/api";
import Grid from "@mui/material/Grid";
import DataTable from "../componets/DataTableComponent";
import IconUI from "../componets/ui/icon_ui";
import { NotificacionContext } from "../context/notificacion_context";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { useNavigate } from "react-router-dom";
import PagoLinea from "../componets/PagoEnLinea";
import { GlobalContext } from "../context/global_context";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box, Checkbox, FormControlLabel, Modal,Paper } from "@mui/material";
import Button from "@mui/material/Button";
import ArticleIcon from '@mui/icons-material/Article';
import Tooltip from '@mui/material/Tooltip';
import { Typography } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';


const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  height: "auto",
  p: 4,
};

const renderWorkshopValues = (workshops, { field, fallback }) => {
  const entries = Array.isArray(workshops) ? workshops : [];
  const renderValue = (value, key) => (
    <div
      key={key}
      style={{ height: "60px", display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <span title={value} style={{ maxWidth: "240px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {value}
      </span>
    </div>
  );

  return (
    <div>
      {entries.length
        ? entries.map(workshop => renderValue(workshop[field] || fallback, workshop.id))
        : renderValue(fallback, "empty")}
    </div>
  );
};

const UsuariosView = () => {


  const [state, setState] = useState({
    talleres: [],
    lineaCaptura:[],
    info: [],
    loading: true,
    openRadio: false,
    lineaPago: {},
    openDetalle:false,
    infoDetalle:[],
    count: 0,
    page: 0,
    rowsPerPage: 50,
  });
  const { showNotification } = useContext(NotificacionContext);
  const navigate = useNavigate();

  const { GlobalState, setGlobalState } = useContext(GlobalContext);
  let nombre = localStorage.getItem("nombre")
  const pagarEnLinea = (taller) => {
    
    setGlobalState({
      ...GlobalState,
      openpagoLinea: true,
      lineaCaptura: taller,
    });
  };

  const obtenerDatosTalleres = async (page) => { 
    setState(prev => ({ ...prev, loading: true }));
    try {
      
      const response = await services("GET", `usuarios/miscursos?page=${page}`);
      
      if (response.status === 200) {
          const respuestaBackend = response.data;
          
          setState(prev => ({
              ...prev,
              talleres: respuestaBackend.data || [], 
              count: respuestaBackend.total,
              page: respuestaBackend.current_page - 1, 
              rowsPerPage: respuestaBackend.per_page,
              loading: false
          }));
      }else{
        setState(prev => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error(error);
      setState(prev => ({ ...prev, loading: false }));
    }
  };
  const handleTableChange = (action, tableState) => {
   
    switch (action) {
      case 'changePage':
        obtenerDatosTalleres(tableState.page + 1);
      
        break;
      default:
        break;
    }
  };

  const optionsTalleres = {
    filter: false,
    sort: false,
    search: false, 
    print: false,
    download: false,
    viewColumns: false,
    selectableRows: "none",
    responsive: "standard",
    serverSide: true, 
    count: state.count,
    page: state.page,
    rowsPerPage: state.rowsPerPage,
    rowsPerPageOptions: [50],
    textLabels: {
      body: { noMatch: "No se encontraron talleres inscritos", toolTip: "Ordenar" },
      pagination: { next: "Siguiente", previous: "Anterior", rowsPerPage: "Filas por página:", displayRows: "de" },
    },
    onTableChange: handleTableChange
  };

  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const columns = [
    {
      name: "Taller",
      label: "Taller",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
         
          const item = state.talleres[dataIndex];
          return renderWorkshopValues(item?.talleres, { field: "nombretaller", fallback: "Sin nombre" });
        },
      },
    },
    {
      name: "Nivel",
      label: "Nivel",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
            const item = state.talleres[dataIndex];
            return renderWorkshopValues(item?.talleres, { field: "nivel", fallback: "-" });
        },
      },
    },
    {
      name: "Fecha-Limite-de-pago",
      label: "Fecha limite de pago",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
            const item = state.talleres[dataIndex];
            return renderWorkshopValues(item?.talleres, { field: "fechavencimientotaller", fallback: "-" });
        },
      },
    },
    {
      name: "status-pago",
      label: "Estado de pago",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
            const item = state.talleres[dataIndex];
            return renderWorkshopValues(item?.talleres, { field: "stastustaller", fallback: "-" });
        },
      },
    },
  ];

  const columnsLC = [
    {
      name: "nombre",
      label: "Nombre",
      align: "center",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let nombre = `${state.lineaCaptura[dataIndex].nombre}`;
          return (
            <div
              style={{ height: "60px", minWidth:"60%"}}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {nombre}
            </div>
          );
        },
      },
    },
    {
      name: "linea_captura",
      label: "Linea de captura ",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let Descripcion = state.lineaCaptura[dataIndex].linea_captura;
          return (
            <div
              style={{ height: "60px", }}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {Descripcion}
            </div>
          );
        },
      },
    },
    {
      name: "fechaplinea",
      label: "Fecha limite de pago",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let imagen = state.lineaCaptura[dataIndex].fechaplinea;
          return (
            <div
              style={{ height: "60px", minWidth:"100px"}}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {imagen}
            </div>
          );
        },
      },
    },
    {
      name: "importe",
      label: "Importe",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex, i) => {
          let imagen = state.lineaCaptura[dataIndex].importe;
          return (
            <div
              style={{ height: "60px" }}
              className={
                i % 2 === 0
                  ? "d-flex align-items-center justify-content-center"
                  : "d-flex align-items-center justify-content-center"
              }
            >
              {imagen}
            </div>
          );
        },
      },
    },
    {
      name: "acciones",
      label: "Acciones",

      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (dataIndex, i) => (
          <>
            <div
              style={{ height: "60px", minWidth:"60%" }}
              className={
                i % 2 === 0
                  ? "w-100 d-flex align-items-center justify-content-center "
                  : "w-100 d-flex justify-content-center align-items-center "
              }
            >
              <div
                style={{ height: 30, width: 30, zIndex: 0 }}
                className="cta cta--primary cta--icon icon_btn "
                onClick={() => {
                  handleModal(state.lineaCaptura[dataIndex]);
                  
                }}
              > 
      
                <IconUI size={"20px"} color={"black"}> 
                  {state.lineaCaptura[dataIndex].status === "pendiente" ? (
                    <MonetizationOnIcon/>
                  ) : (
                     <ArticleIcon/>
                    
                  )}
                </IconUI>
              </div>
                
              <Tooltip title="Ver detalle">
              <div
                style={{ height: 30, width: 30, zIndex: 0 }}
                className="cta cta--primary cta--icon icon_btn ms-1"
                onClick={() => {
                  handleDetalle(state.lineaCaptura[dataIndex]);
                }}
              >
                <IconUI size={"20px"} color={"black"}>
                  <VisibilityIcon />
                </IconUI>
              </div>
            </Tooltip>
            </div>
          </>
        ),
      },
    },
  ];

  const handleModal = (taller) => {
    
    if (taller.status === "pendiente") {
      setState({ ...state, openRadio: true, lineaPago: taller });
    } else {
      pagarEnLinea(taller);
    }
  };

  const handleDetalle = async (lineaCaptura) =>{
    try{
      const body = {
        linea_captura : lineaCaptura.linea_captura,
      };
      const responseDetalles = await services ('POST', `linea-captura/conceptos`, body)
     
      setState({...state, openDetalle:true, infoDetalle: responseDetalles.data })

  
    }catch{
    }
   
  }


  const handlePago = () => {
    pagarEnLinea(state.lineaPago);
    setState({ ...state, openRadio: false });
  };

  const idAlumno = localStorage.getItem('id');
  
  const api = async () => {
    await obtenerDatosTalleres(1);
    const listarLc = await services('GET',`linea-captura/detalles-alumno/${idAlumno}`)
    
    if ( listarLc.status === 200) {   
      if ( listarLc.data.data.length === 0) {
        setState({
          ...state,
          // talleres: [],
          // info: { alumno: [] },
          lineaCaptura:[],
          loading: false,
        });
      } else {
        setState(prev => ({ ...prev,  lineaCaptura:listarLc.data.data,loading: false }));
      }
    } else {
      showNotification(
        "error",
        "Hubo un error",
        
        null,
        4
      );
    }
  };

  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (localStorage.getItem("rol") !== "Alumno") {
        navigate("/");
      } else {
        api();
      }
    }

    setGlobalState({ ...GlobalState, openpagoLinea: false });
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
let isMounted = true;
    if (isMounted) {
        setChecked(false);
    }
       return () => {
      isMounted = false;
    };
  }, [GlobalState.openpagoLinea])

  return (
    <>
      {state.loading ? (
        <div style={{ height: "calc(100vh - 80px)" }}>
          <span className="loader"></span>
        </div>
      ) : GlobalState.openpagoLinea ? (
        <PagoLinea />
      ) : (
        <div style={{ height: "calc(100vh - 80px )", width:"100%"}}>

              <div className="container mt-5">
                <Grid container spacing={2}>
                  <Grid align="center" item xs={12} sm={12} md={12}>
                    <h4>
                      Hola <b>{nombre}</b>, estos son tus talleres
                      del trimestre.
                    </h4>
                    <hr></hr>
                  </Grid>
                </Grid>
              </div>
                <div className="container mt-5">
                <h4 className="text-center text--guinda">
                  Mis líneas de captura
                </h4>
              </div>

              <div className="table-container">
                <DataTable
                  data={state.lineaCaptura}
                  title={"Líneas de captura"}
                  columns={columnsLC}
                />
              </div>

              <div className="container mt-5">
                <h4 className="text-center text--guinda">
                  Mis cursos
                </h4>
              </div>

              <div className="table-container">
                <Box sx={{ flexGrow: 1 }}>
                  <Grid className="container mt-5 mb-5">
                    <Grid item xs={8}>
                      <MUIDataTable
                        title={"Talleres"}
                        data={state.talleres}
                        columns={columns}
                        options={optionsTalleres}
                      />
                    </Grid>
                  </Grid>
                </Box>
                
              </div>
        </div>
      )}
      <Modal
        open={state.openRadio}
        onClose={() => setState({ ...state, openRadio: false })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal} className="modal-content">
          <Grid
            container
            spacing={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "2%",
            }}
          >
            <h4 style={{ textAlign: "center" }}>Aviso de Privacidad</h4>

            <span
              id="label-titulo"
              style={{ textAlign: "justify", height: "100%", overflow: "auto" }}
            >
              Tu privacidad es importante para nosotros. Como parte de nuestro
              compromiso de proteger tus datos personales, te instamos a leer nuestro
              aviso de privacidad. En él, encontrarás información detallada sobre
              cómo recopilamos, utilizamos y protegemos la información que nos
              proporcionas. Puedes encontrar nuestro aviso de privacidad en el
              siguiente enlace: {" "}
              <a
                target="_blank"
                href={process.env.PUBLIC_URL + "/AVISO_PRIVACIDAD.pdf"}
                rel="noreferrer"
              >
                Aviso de Privacidad
              </a>
              . Al utilizar nuestros servicios, confirmas que has leído y entendido
              nuestra política de privacidad y aceptas los términos establecidos en
              ella.
            </span>
            <FormControlLabel
              style={{
                margin: 0,
                position: "inherit",
                transformOrigin: "none",
                transform: "none",
              }}
              label="He leido el Aviso de privacidad"
              control={
                <Checkbox
                  checked={checked}
                  onChange={handleChange}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
            <Button
              onClick={handlePago}
              className={`${!checked ? "cta--guinda_disabled" : "cta--guinda"}`}
              variant="contained"
              disabled={!checked}
            >
              Continuar
            </Button>
          </Grid>

          <Grid
            container
            spacing={6}
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            ></Grid>
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={state.openDetalle}
        onClose={() => setState({ ...state, openDetalle:false, infoDetalle:[]})}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModal} className="modal-content">
          <Grid 
            container
            spacing={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "2%",
            }}
          >

              <IconButton
                aria-label="close"
                onClick={() => setState({ ...state, openDetalle:false ,infoDetalle:[]})}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
              <CloseIcon />
              </IconButton>
            <Typography variant="h6" component="h2" sx={{ mb: 2, textAlign: 'center' }}>
              Detalle de Pagos
            </Typography>
           

            <Grid container spacing={2}> 
              <Grid  item xs={12}>

                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell><strong>Concepto</strong></TableCell>
                        <TableCell align="right"><strong>Importe</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {state.infoDetalle?.data?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{item.concepto}</TableCell>
                          <TableCell align="right">${item.importe.toFixed(2)}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                
              </Grid>

            </Grid>


          </Grid>
        </Box>

      </Modal>

    </>
  );
};

export default UsuariosView;
